// generic video play with play/pause button
$('.jsVideo').each(function() {
    const $this = $(this);
    const video = $this[0];
    const videoContainer =
        $this
            .closest('.video-container')
    const playButton = 
        videoContainer
            .find('.btn-play');
    const pauseButton = 
        videoContainer
            .find('.btn-pause');

    $this.on('click', function() {
        if (video.paused) {
            video.play();
            videoContainer
                .addClass('video-playing')
            playButton
                .removeClass('is-visible')
        } else {
            video.pause();
            videoContainer
                .removeClass('video-playing')
            playButton
                .addClass('is-visible')
        }
    });
});
